<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">

      <!-- Table Top -->
      <b-row class="align-items-center">

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />

          <Button
            :label="$t('Show Summary')"
            size="md"
            show-icon
            class="mr-1"
            :disabled="disabled"
            @click="fetchProvisionSummary"
          />
          <b-dropdown
            id="dropdown-1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :text="$t('Provision')"
            variant="primary"
            class="mr-1"
            :disabled="disabled"
          >
            <b-dropdown-item @click="postProvision">
              {{ $t('Post Provision') }}
            </b-dropdown-item>
            <b-dropdown-item @click="showReevaluateProvision">
              {{ $t('Re-evaluate Provision') }}
            </b-dropdown-item>
          </b-dropdown>

          <SwitchButton
            v-model="makeFullProvision"
            :label="$t('Make Full Provision')"
            name="make-full-provision"
            class="mt-2 ml-1"
            :on-change="onMakeFullProvision"
            :readonly="disabled"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end  mb-1 mb-md-0">
            <b-dropdown
              id="dropdown-1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :text="$t('Export')"
              variant="primary"
              class="mr-1"
              :disabled="isDisabled"
            >
              <b-dropdown-item
                v-for="item in exportTypes"
                :key="item.text"
                @click="item.handler"
              >
                {{ item.text }}
              </b-dropdown-item>
            </b-dropdown>
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
          <div class="d-flex align-items-center justify-content-lg-end">
            <!-- <SwitchButton
              v-model="isCurrentFinancialDate"
              label="Use Current Financial Date"
              name="current-date-date"
              class="mt-2 ml-1"
              :on-change="onToggleFinancialDate"
            /> -->
            <!-- <DatePickerField
              id="financial-date"
              v-model="provisionedDate"
              :min-date="new Date()"
              label=""
              :config="datePickerConfig"
              placeholder="Select provision date"
              :disabled="isCurrentFinancialDate"
              :readonly="isCurrentFinancialDate"
            /> -->
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="provisionedLoanRef"
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :items="provisionedLoanList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <template #cell(select)="data">
        <b-form-group class="mt-2">
          <b-form-checkbox
            v-model="data.item.select"
          />
        </b-form-group>
      </template>

      <template #cell(loanAmount)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(totalPrincipalOutstanding)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(principalNotYetDue)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(principalDueAndUnpaid)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(interestDueAndUnpaid)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(lastProvisionedAmount)="data">
        {{ toBalance(data.value) }}
      </template>

      <template #cell(expectedProvisionAmount)="data">
        {{ toBalance(data.value) }}
      </template>
      <template #cell(lastProvisionedDate)="data">
        {{ data.value ? toDateWithYearFirst(data.value) : '' }}
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />
    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      ok-only
      ok-variant="outline-secondary"
      :ok-title="$t('Close')"
      centered
      no-close-on-backdrop
      size="lg"
      :title="$t('Summary')"
    >
      <b-table
        ref="summaryRef"
        :busy="isBusy"
        :items="summaryList"
        :per-page="pageSize"
        :current-page="currentPage"
        responsive
        :fields="translatedSummaryTableHeaders"
        primary-key="id"
        show-empty
        :empty-text="$t('No records available')"
        class="position-relative"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              class="align-middle"
              variant="primary"
            />
          </div>
        </template>
      </b-table>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="handleSubmit"
      @cancel="resetFilters"
    >
      <validation-observer ref="loanProvisioningRules">
        <b-form>
          <b-row class="match-height">
            <!-- Loan Account No -->
            <b-col md="6">
              <InputField
                id="loan-account-no"
                v-model="filter.accountNumber"
                :label="$t('Loan Account Number')"
                :placeholder="$t('Enter loan account no')"
                type="text"
              />
            </b-col>
            <!-- Loan Account No -->

            <!-- Product -->
            <b-col md="6">
              <SelectField
                id="product"
                v-model="filter.productCode"
                :label="$t('Product')"
                :placeholder="$t('Select Product')"
                :options="productOptions"
                :reduce="option => option.value"
                item="label"
              />
            </b-col>
            <!-- Product -->

            <!-- Branch -->
            <b-col md="6">
              <SelectField
                id="branch"
                v-model="filter.branchCode"
                :label="$t('Branch')"
                :placeholder="$t('Select Branch')"
                :options="branchOptions"
                :reduce="option => option.value"
                item="label"
                @input="getBranchValue(filter.branchCode)"
              />
            </b-col>
            <!-- Branch -->

            <!-- Loan Classification -->
            <b-col md="6">
              <SelectField
                id="Loan Classification"
                v-model="filter.classificationStatus"
                :label="$t('Loan Classification')"
                :placeholder="$t('Select Loan Classification')"
                :options="translatedLoanProvisioningOptions"
                :reduce="option => option.value"
                item="label"
              />
            </b-col>
            <!-- Loan Classification -->

            <!-- Provision Date -->
            <b-col md="6">
              <DatePickerField
                id="provision-date"
                v-model="filter.provisionedDate"
                rules="required"
                :min-date="new Date()"
                :label="$t('Provision Date')"
                :error-name="$t('Provision Date')"
                :config="datePickerConfig"
                :placeholder="$t('Provision Date')"
              />
            </b-col>
            <!-- Provision Date -->
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <!-- Filter modal -->
    <b-modal
      id="show-reevaluate-provision-modal"
      ref="my-modal"
      :ok-title="$t('Re-evaluate')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('Re-evaluate Provision')"
      modal-footer
      @ok="handleReevaluateProvision"
      @hidden="resetModal"
    >
      <validation-observer ref="reevaluateProvisionRules">
        <b-form>
          <b-row class="match-height">
            <!-- Financial Date -->
            <b-col
              md="12"
              class="mt-2"
            >
              <DatePickerField
                id="financial-date"
                v-model="reevaluateFormData.financialDate"
                rules="required"
                :min-date="new Date()"
                :label="$t('Financial Date')"
                :error-name="$t('Financial Date')"
                :config="datePickerConfig"
                :placeholder="$t('Financial Date')"
              />
            </b-col>
          <!-- Financial Date -->
          </b-row>
        </b-form>
      </validation-observer>
      <FullScreenSpinner :show="showReevaluteSpinner" />
    </b-modal>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BModal, BFormGroup, BFormCheckbox, BDropdown, BDropdownItem, BForm,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { permissionMixin } from '@core/mixins/permission'
import { toBalance, formatAmount, toFormatAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import { gender, accessLevel } from '../../../../helpers/data'
import getStatusColor from '../../../../helpers/getStatusColor'
import Button from '../../../components/button/Button.vue'
import SwitchButton from '../../../components/switch/Switch.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import { accountPermissions } from '@/helpers/permissions'
import { getMinusOneDayDate, toDateWithYearFirst } from '@/helpers/formatDate'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormCheckbox,
    TablePagination,
    BModal,
    BSpinner,
    TableEntries,
    SelectField,
    InputField,
    Button,
    FullScreenSpinner,
    SwitchButton,
    DatePickerField,
    BDropdown,
    BDropdownItem,
    BForm,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYearFirst,
      formatAmount,
      toFormatAmount,
      isLoading: false,
      isReadonly: false,
      isEditable: false,
      isFullName: false,
      isDisabled: false,
      isCurrentFinancialDate: true,
      provisionedDate: null,
      showSpinner: false,
      showReevaluteSpinner: false,
      sortBy: 'name',
      required,
      minPhoneVal,
      maxPhoneVal,
      toBalance,
      modalTitle: this.$t('Create Account Officer'),
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'select', sortable: true, label: 'Select' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Loan Account No' },
        { key: 'linkedNumber', sortable: true, label: 'Linked Account No' },
        { key: 'product', sortable: true, label: 'Product Name' },
        { key: 'branch', sortable: true, label: 'Branch' },
        { key: 'loanAmount', sortable: true, label: 'Disbursed Amount' },
        { key: 'totalPrincipalOutstanding', sortable: true, label: 'Total Principal Outstanding' },
        { key: 'principalNotYetDue', sortable: true, label: 'Principal Not Yet Due' },
        { key: 'principalDueAndUnpaid', sortable: true, label: 'Principal Due and UnPaid' },
        { key: 'interestDueAndUnpaid', sortable: true, label: 'Interest Due and Paid' },
        { key: 'daysPastDue', sortable: true, label: 'Days Past Due' },
        { key: 'classificationStatus', sortable: true, label: 'Loan Status Classification' },
        { key: 'lastProvisionedAmount', sortable: true, label: 'Last Provisioned Amount' },
        { key: 'expectedProvisionAmount', sortable: true, label: 'Expected Provision Amount' },
        { key: 'increaseOrDecrease', sortable: true, label: 'Increase/Decrease in Provision' },
        { key: 'lastProvisionedDate', sortable: true, label: 'Last Provisioned Date' },
      ],
      summaryTableHeaders: [
        { key: 'classificationStatus', sortable: true, label: 'Classification Status' },
        { key: 'expectedProvisionAmount', sortable: true, label: 'Expected Provision Amount' },
        { key: 'totalPrincipalOutstanding', sortable: true, label: 'Total Principal Outstanding' },
      ],
      exportTypes: [
        {
          text: 'CSV',
          handler: () => this.csvExport(),
        },
        {
          text: 'Excel',
          handler: () => this.excelExport(),
        },
      ],
      makeFullProvision: true,
      isFullProvision: true,
      genderOptions: gender,
      getStatusColor,
      buttonLabel: this.$t('Save'),
      accountOfficerFormData: {
        lastName: '',
        otherNames: '',
        staffID: '',
        phoneNumber: '',
        accessLevel: null,
        gender: null,
        address: '',
        branchCode: '',
        status: '',
        id: '',
        name: '',
      },
      filter: {
        accountNumber: '',
        productCode: '',
        branchCode: '',
        classificationStatus: '',
        provisionedDate: '',
        sortColumn: '',
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: '',
        defaultDate: '',
      },
      reevaluateFormData: {
        financialDate: null,
      },
      branchRefCode: '',
      accessLevelOptions: accessLevel,
      provisionedLoanList: [],
      exportSearchData: [],
      summaryList: [],
      productOptions: [],
      exportData: [],
      loanProvisioningOptions: [
        { label: 'Performing', value: 'Performing' },
        { label: 'Pass and Watch', value: 'PassAndWatch' },
        { label: 'Substandard', value: 'Substandard' },
        { label: 'Doubtful', value: 'Doubtful' },
        { label: 'Lost', value: 'Lost' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
      userDetails: 'auth/getCurrentUser',
      currentFinancialDate: 'operations/getCurrentFinancialDate',
    }),
    getPreviousFinancialDates() {
      return getMinusOneDayDate(this.currentFinancialDate.financialDate)
    },
    disabled() {
      return !this.filter.provisionedDate || !this.provisionedLoanList.length
    },
    select() {
      return this.provisionedLoanList.filter(module => module.select)
    },
    exportItems() {
      return this.exportSearchData.map((item, index) => ({
        'S/N': index + 1,
        'Account Name': item.accountName,
        'Loan Account No': item.accountNumber,
        'Linked Account No': item.linkedNumber,
        'Product Name': item.product,
        Branch: item.branch,
        'Disbursed Amount': item.loanAmount ? formatAmount(item.loanAmount) : 0,
        'Total Principal Outstanding': item.totalPrincipalOutstanding ? formatAmount(item.totalPrincipalOutstanding) : 0,
        'Principal Not Yet Due': item.principalNotYetDue ? formatAmount(item.principalNotYetDue) : 0,
        'Principal Due And Unpaid': item.principalDueAndUnpaid ? formatAmount(item.principalDueAndUnpaid) : 0,
        'Interest Due And Unpaid': item.interestDueAndUnpaid ? formatAmount(item.interestDueAndUnpaid) : 0,
        'Days Past Due': item.daysPastDue,
        'Loan Classification Status': item.classificationStatus,
        'Last Provisioned Amount': item.lastProvisonedAmount ? formatAmount(item.lastProvisonedAmount) : 0,
        'Expected Provision Amount': item.expectedProvisionAmount ? formatAmount(item.expectedProvisionAmount) : 0,
        'Increase/Decrease in Provision': item.increaseOrDecrease,
        'Last Provisioned Date': item.lastProvisionedDate ? this.toDateWithYearFirst(item.lastProvisionedDate) : '',
      }))
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedSummaryTableHeaders() {
      return this.summaryTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedLoanProvisioningOptions() {
      return this.loanProvisioningOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchProvisionedLoans(this.isFullProvision)
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchProvisionedLoans(this.isFullProvision)
    },
  },
  mounted() {
    this.datePickerConfig.maxDate = this.getPreviousFinancialDates
    this.fetchLoanProducts()
  },
  methods: {
    ...mapActions({
      getProvisionedLoans: 'account/getProvisionedLoans',
      getProvisionedLoanSummary: 'account/getProvisionedLoanSummary',
      getProducts: 'account/getProducts',
      postLoanProvision: 'account/postLoanProvision',
      reevaluateProvision: 'account/reevaluateProvisionAction',
      getBranchByCode: 'operations/getBranchByCode',
      downloadLoanProvisioningReport: 'reports/downloadLoanProvisioningReport',
    }),

    async handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.loanProvisioningRules.validate().then(async success => {
        if (success) {
          this.fetchProvisionedLoans()
        }
      })
    },
    async fetchProvisionedLoans() {
      try {
        this.isBusy = true
        this.hideModal('modal-filter')
        const response = await this.getProvisionedLoans({
          search: { ...this.filter, ProvisionedDate: this.toDateWithYearFirst(this.filter.provisionedDate) },
          page: this.currentPage,
          limit: this.perPage,
        })
        const { status, data } = response
        if (status === 200 && data.data.length) {
          if (this.isFullProvision) {
            this.provisionedLoanList = data.data.map(item => ({
              ...item,
              select: true,
            }))
          } else {
            this.provisionedLoanList = data.data.map(item => ({
              ...item,
              select: false,
            }))
          }

          this.totalCount = data.recordCount
        } else {
          this.provisionedLoanList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async onMakeFullProvision(value) {
      this.isFullProvision = value
      this.fetchProvisionedLoans(this.isFullProvision)
    },
    onToggleFinancialDate(value) {
      if (value) {
        this.provisionedDate = null
      }
    },
    postProvision() {
      const provisionLoanAction = async () => {
        try {
          const res = this.provisionedLoanList.filter(item => item.select === true)

          if (res.length) {
            this.showSpinner = true
            const response = await this.postLoanProvision({
              provisions: res,
              isCurrentFinancialDate: false,
              provisionedDate: this.toDateWithYearFirst(this.filter.provisionedDate),
              initiatedBy: this.userDetails.email,
            })
            const { status, data } = response
            if (status === 200 && data) {
              const requestText = this.$t('Your request to Post Provision Loan was successful. Post Provision Loan reference number is')
              this.alertSuccess({ text: `${requestText} ${data.referenceNumber}` })
            }
          } else {
            this.alertError({ text: this.$t('Please select loans you will like to provision') })
          }
        } catch (error) {
          this.handleError(error)
        } finally {
          this.showSpinner = false
        }
      }
      this.confirm(provisionLoanAction, { title: '', text: this.$t('Are you sure you want to Post these Provision Loans?') })
    },
    showReevaluateProvision() {
      this.$root.$emit('bv::show::modal', 'show-reevaluate-provision-modal')
    },
    async handleReevaluateProvision(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.reevaluateProvisionRules.validate().then(async success => {
        if (success) {
          this.confirm(this.submitReevaluateProvision, { title: '', text: this.$t('Are you sure you want to Re-evaluate this Loan Provision?') })
        }
      })
    },
    async submitReevaluateProvision() {
      try {
        const formData = {
          financialDate: this.reevaluateFormData.financialDate,
          initiatedBy: this.userDetails.email,
          approvedBy: '',
        }
        this.showReevaluteSpinner = true
        const response = await this.reevaluateProvision({
          formData, permission: accountPermissions.VIEW_LOAN_PROVISIONING,
        })
        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.alertSuccess({ text: this.$t('Your request to Re-evaluate Provision was successful') })
          this.showReevaluteSpinner = false
        } else if (status === 200 && !data.isSuccessful) {
          this.alertError({ text: data.message })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showReevaluteSpinner = false
      }
    },
    async fetchProvisionSummary() {
      try {
        this.showSpinner = true
        const response = await this.getProvisionedLoanSummary({
          provisionDate: this.toDateWithYearFirst(this.filter.provisionedDate),
        })
        this.summaryList = response.data.data.map(item => ({
          ...item,
          expectedProvisionAmount: toBalance(item.expectedProvisionAmount),
          totalPrincipalOutstanding: toBalance(item.totalPrincipalOutstanding),
        }))
        this.$root.$emit('bv::show::modal', 'modal-lg')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    async fetchLoanProducts() {
      try {
        const response = await this.getProducts({
          search: { type: 'Loan' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_LOAN_PROVISIONING,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.productOptions = data.data.filter(items => items.status === 'Active').map(item => ({
            label: item.name,
            value: item.code,
          }))
        } else {
          this.productOptions = []
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async getBranchValue(dataValue) {
      if (dataValue !== null) {
        try {
          const response = await this.getBranchByCode(dataValue)
          const { status, data } = response
          if (status === 200 && data) {
            this.branchRefCode = data
          }
        } catch (error) {
          this.alertError({ text: error })
        } finally {
          this.isBusy = false
        }
      }
    },
    async csvExport() {
      try {
        if (this.filter.provisionedDate === '') {
          this.alertError({ text: this.$t('Provision Date must not be empty') })
        } else {
          this.isBusy = true
          const filterData = { ...this.filter, makeFullProvision: this.makeFullProvision }
          const response = await this.downloadLoanProvisioningReport({
            search: filterData,
            page: this.currentPage,
            limit: this.perPage,
            fileExportFormat: 1,
            permission: accountPermissions.VIEW_LOAN_PROVISIONING,
          })
          if (response.status === 200) {
            this.alertSuccessCustom({
              text: this.$t('Your download is in progress and might take a little longer. Go to your'),
              link: {
                text: this.$t('Download Manager'),
                route: { name: 'download-manager' },
              },
              afterLinkText: this.$t('to access the completed file.'),
            })
          } else if (response.status === 504) {
            this.alertSuccessCustom({
              text: this.$t('Your download request is still processing, keep checking the'),
              link: {
                text: this.$t('Download Manager'),
                route: { name: 'download-manager' },
              },
              afterLinkText: this.$t('for status.'),
            })
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },
    async excelExport() {
      try {
        if (this.filter.provisionedDate === '') {
          this.alertError({ text: this.$t('Provision Date must not be empty') })
        } else {
          this.isBusy = true
          const filterData = { ...this.filter, makeFullProvision: this.makeFullProvision }
          const response = await this.downloadLoanProvisioningReport({
            search: filterData,
            page: this.currentPage,
            limit: this.perPage,
            fileExportFormat: 0,
            permission: accountPermissions.VIEW_LOAN_PROVISIONING,
          })
          if (response.status === 200) {
            this.alertSuccessCustom({
              text: this.$t('Your download is in progress and might take a little longer. Go to your'),
              link: {
                text: this.$t('Download Manager'),
                route: { name: 'download-manager' },
              },
              afterLinkText: this.$t('to access the completed file.'),
            })
          } else if (response.status === 504) {
            this.alertSuccessCustom({
              text: this.$t('Your download request is still processing, keep checking the'),
              link: {
                text: this.$t('Download Manager'),
                route: { name: 'download-manager' },
              },
              afterLinkText: this.$t('for status.'),
            })
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },
    resetModal() {
      this.reevaluateFormData = { ...null }
    },
    resetFilters() {
      this.filter = { ...null }
      // this.filter.provisionedDate = null
      this.isCurrentFinancialDate = false
    },
    resetFilter() {
      this.filter = { ...null }
      // this.filter.provisionedDate = null
      this.isCurrentFinancialDate = false
      this.fetchProvisionedLoans()
    },
  },
}
</script>
